import {Button} from "reactstrap";

const Stripe = (pro) => {
  const pay=()=>{
    const formData = {};
    formData.price=100;
    formData.name='test purchase';
    formData.description= 'first run test';
    formData.url =window.location.href.match(/local/) ? 'local.esketchos.art:3000/stripe' : 'new.esketchos.art/stripe';

    fetch(window.location.href.match(/local/) ? 'http://localhost:3018/checkout': '/checkout' ,
      {
        headers: {
        "Content-Type": "application/json",
          // "Content-Type": "multipart/form-data",
        },
        method: "POST",
        body: JSON.stringify(formData)
      }
    ).then(response => response.json()).then(res=>console.log(res.res))


  }
  return (<div>

    <Button onClick={a=>pay()}>pay</Button>

  </div>
  )
}

export default Stripe;
